export default __webpack_public_path__ + "static/media/3028.5786b481.jpg";